module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "page-wrap"
  }, [_c('div', {
    staticClass: "container product"
  }, [_c('div', {
    staticClass: "box-content"
  }, [_c('h2', [_vm._v("Customize Your Order")]), _vm._v(" "), _c('div', [_c('p', [_vm._v("\n                        Enter an inscription below to customize your brick.\n                        Each line allows for " + _vm._s(_vm.info.max_chars) + " characters per line.\n                        View our "), _c('a', {
    staticClass: "text-danger underline pointer",
    on: {
      "click": function($event) {
        _vm.showInscriptionGuidelines()
      }
    }
  }, [_vm._v("inscription policy")]), _vm._v(" for more information.\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "prod-container"
  }, [_c('img', {
    staticClass: "prod-img",
    attrs: {
      "src": _vm.getProductImage(_vm.logo)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "prod-replica"
  }, [_c('div', {
    staticClass: "prod-replica-table"
  }, [_c('div', {
    staticClass: "prod-replica-table-td",
    class: _vm.product.classes
  }, _vm._l((_vm.product.max_lines), function(n) {
    return _c('p', [_vm._v(_vm._s(_vm.lines[n - 1]))])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.product.description)
    }
  }), _vm._v(" "), _c('h4', [_vm._v("$ " + _vm._s(_vm.product.price))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Brick Inscription:")]), _vm._v(" "), _c('div', {
    staticClass: "brick-text-form"
  }, _vm._l((_vm.product.max_lines), function(n) {
    return _c('div', {
      staticClass: "form-group row no-gutter"
    }, [_c('div', {
      staticClass: "col-md-2"
    }, [_c('label', {
      attrs: {
        "for": 'l-' + n
      }
    }, [_vm._v("Line " + _vm._s(n) + ":")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-10"
    }, [_c('input', {
      staticClass: "form-control",
      attrs: {
        "line-id": 'l-' + n,
        "id": 'l-' + n,
        "maxlength": _vm.product.max_characters,
        "size": _vm.product.max_characters
      },
      domProps: {
        "value": _vm.lines[n - 1]
      },
      on: {
        "keydown": function($event) {
          _vm.withAnyKeyDown($event)
        },
        "keyup": function($event) {
          _vm.withAnyKeyUp($event)
        },
        "input": function($event) {
          _vm.withInput($event)
        }
      }
    })])])
  })), _vm._v(" "), _c('p', [_vm._v("Need inspiration?\n                            "), _c('a', {
    staticClass: "text-danger pointer",
    on: {
      "click": function($event) {
        _vm.showInscriptionExamples()
      }
    }
  }, [_vm._v("Click here")]), _vm._v("\n                            for inscription examples.\n                        ")])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.isMultiLogoAllowed) ? _c('preferred-logo', {
    ref: "preflog",
    attrs: {
      "options": _vm.product.options || {},
      "logo": _vm.logo,
      "on-logo-change": "onCartItemLogoChange"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "btn-wrap text-right"
  }, [_c('a', {
    staticClass: "btn btn-danger btn-md",
    on: {
      "click": _vm.saveInscription
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger btn-md",
    on: {
      "click": _vm.cancelEditing
    }
  }, [_vm._v("Cancel")])])])])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('p', [_c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v("\n                            All inscriptions will be subject to approval in accordance with the inscription guidelines.\n                        ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67e275b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cart/EditInscription.vue
// module id = e6Od
// module chunks = 1